// Ghi .gitignore: tạo mới nếu chưa có, merge content nếu đã có. Merge logic
// dùng marker `# === avatar === ... # === /avatar ===`: replace block đó nếu
// tồn tại, append nếu chưa. Logic marker thuần nằm ở avatar-block-text-ops.ts
// (ticket #138 phase-01 — DRY, dùng chung cho info/exclude).
import { existsSync, readFileSync, writeFileSync } from "node:fs";
import { join } from "node:path";
import { mergeAvatarBlockIntoContent } from "./avatar-block-text-ops.js";

export function writeOrMergeGitignore(folderPath: string, avatarBlock: string): void {
  const path = join(folderPath, ".gitignore");

  if (!existsSync(path)) {
    writeFileSync(path, avatarBlock, "utf8");
    return;
  }

  const existing = readFileSync(path, "utf8");
  writeFileSync(path, mergeAvatarBlockIntoContent(existing, avatarBlock), "utf8");
}
